<template>
  <a-card :bordered="false" style="min-height: 300px">
    <custom-page-table
      :queryParams="queryParams"
      style="margin-top:10px;"
      ref="tableList"
      :columns="columns"
      :requestPromise="getProductList"
    >
    </custom-page-table>
  </a-card>
</template>

<script>
export default {
  name: 'ProductSynchronousRecording',
  data() {
    return {
      queryParams: {},
      columns: [
        {
          title: '同步时间',
          dataIndex: 'addTime',
          width: '160px'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '商家编码（原系统商品ID）',
          dataIndex: 'proId',
          width: '210px'
        },
        {
          title: '飞猪商品ID',
          dataIndex: 'feiZhuProId',
          width: '160px'
        }
      ],
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId
    }
  },
  props: {
    authId: {
      type: String | Number,
      default: ''
    }
  },

  created() {
    this.queryParams = { authId: this.authId }
  },
  methods: {
    getProductList(params) {
      return this.getHttpServices().getServerApiService().post('feizhu/taobao/querySyncProList', params)
    }
  }
}
</script>

<style scoped>

</style>